import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3065acdb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-title align-items-start flex-column" }
const _hoisted_2 = {
  key: 0,
  class: "text-muted mt-1 fw-bold fs-7"
}
const _hoisted_3 = { class: "card-toolbar d-flex align-items-center gap-2" }
const _hoisted_4 = {
  key: 0,
  class: "badge badge-light-warning",
  title: "Dữ liệu có thể đã cũ"
}
const _hoisted_5 = {
  key: 1,
  class: "text-muted fs-8"
}
const _hoisted_6 = ["title"]
const _hoisted_7 = {
  key: 3,
  class: "dashboard-widget__content"
}
const _hoisted_8 = {
  key: 0,
  class: "dashboard-widget__fetching-bar"
}

import { computed, useSlots } from 'vue';
import WidgetState from '@/components/dashboard/WidgetState.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardWidget',
  props: {
    title: {},
    subtitle: { default: '' },
    loading: { type: Boolean, default: false },
    error: { type: Boolean, default: false },
    empty: { type: Boolean, default: false },
    isStale: { type: Boolean, default: false },
    generatedAt: { default: null },
    errorMessage: { default: 'Vui lòng thử lại sau hoặc kiểm tra kết nối mạng.' },
    emptyTitle: { default: 'Không có dữ liệu' },
    emptyText: { default: 'Chưa có dữ liệu để hiển thị cho phạm vi hiện tại.' },
    enableFullscreen: { type: Boolean, default: false },
    isFullscreen: { type: Boolean, default: false },
    compact: { type: Boolean, default: false },
    bare: { type: Boolean, default: false },
    hasCachedContent: { type: Boolean, default: false }
  },
  emits: ["retry", "toggle-fullscreen"],
  setup(__props: any) {

const props = __props;



const slots = useSlots();

const lastUpdatedLabel = computed(() => {
  if (!props.generatedAt) {
    return '';
  }
  try {
    const date = new Date(props.generatedAt);
    if (Number.isNaN(date.getTime())) {
      return '';
    }
    return `Cập nhật: ${date.toLocaleString('vi-VN')}`;
  } catch {
    return '';
  }
});

// Ensure slot presence is tracked for future extensions
void slots;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card dashboard-widget", {
      'dashboard-widget--fullscreen': _ctx.isFullscreen,
      'dashboard-widget--compact': _ctx.compact,
      'dashboard-widget--bare': _ctx.bare,
    }])
  }, [
    (!_ctx.bare)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["card-header border-0", _ctx.compact ? 'pt-4 pb-0' : 'pt-5'])
        }, [
          _createElementVNode("h3", _hoisted_1, [
            _createElementVNode("span", {
              class: _normalizeClass(["card-label fw-bolder mb-1", _ctx.compact ? 'fs-6' : 'fs-3'])
            }, _toDisplayString(_ctx.title), 3),
            (_ctx.subtitle)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.subtitle), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_3, [
            (_ctx.isStale)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, " Dữ liệu cũ "))
              : _createCommentVNode("", true),
            (lastUpdatedLabel.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(lastUpdatedLabel.value), 1))
              : _createCommentVNode("", true),
            _renderSlot(_ctx.$slots, "toolbar"),
            (_ctx.enableFullscreen)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  type: "button",
                  class: "btn btn-sm btn-icon btn-light",
                  title: _ctx.isFullscreen ? 'Thu nhỏ' : 'Toàn màn hình',
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle-fullscreen')))
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(
              _ctx.isFullscreen ? 'bi bi-fullscreen-exit' : 'bi bi-arrows-fullscreen'
            )
                  }, null, 2)
                ], 8, _hoisted_6))
              : _createCommentVNode("", true)
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["card-body", _ctx.compact ? 'pt-2 pb-4' : 'pt-3'])
    }, [
      (_ctx.loading && !_ctx.hasCachedContent)
        ? (_openBlock(), _createBlock(WidgetState, {
            key: 0,
            variant: "loading",
            onRetry: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('retry')))
          }))
        : (_ctx.error && !_ctx.hasCachedContent)
          ? (_openBlock(), _createBlock(WidgetState, {
              key: 1,
              variant: "error",
              "error-text": _ctx.errorMessage,
              onRetry: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('retry')))
            }, null, 8, ["error-text"]))
          : (_ctx.empty && !_ctx.loading)
            ? (_openBlock(), _createBlock(WidgetState, {
                key: 2,
                variant: "empty",
                "empty-title": _ctx.emptyTitle,
                "empty-text": _ctx.emptyText
              }, null, 8, ["empty-title", "empty-text"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (_ctx.loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8))
                  : _createCommentVNode("", true),
                _renderSlot(_ctx.$slots, "default")
              ]))
    ], 2)
  ], 2))
}
}

})